import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["name"];
import classList from '../utils/classList';
import Component from '../Component';
export default class Icon extends Component {
  view(vnode) {
    const _vnode$attrs = vnode.attrs,
      {
        name
      } = _vnode$attrs,
      attrs = _objectWithoutProperties(_vnode$attrs, _excluded);

    // @ts-ignore
    attrs.className = classList('icon', name, attrs.className);
    return m("i", Object.assign({
      "aria-hidden": "true"
    }, attrs));
  }
}
flarum.reg.add('core', 'common/components/Icon', Icon);